
import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "./ui/button";

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-background shadow-sm">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center">
            <img 
              src="/lovable-uploads/f8bfc9b3-dcfb-4041-98d4-6d51ffcf45de.png" 
              alt="PhysioAdelaide Logo" 
              className="h-10 w-auto mr-2"
            />
            <span className="text-xl font-bold text-accent">PhysioAdelaide</span>
          </Link>
          <div className="hidden md:flex space-x-8">
            <Link to="/sports-injury" className="text-gray-700 hover:text-accent transition-colors">
              Sports Injury
            </Link>
            <Link to="/chronic-pain" className="text-gray-700 hover:text-accent transition-colors">
              Chronic Pain
            </Link>
            <Link to="/post-surgery" className="text-gray-700 hover:text-accent transition-colors">
              Post Surgery
            </Link>
            <Link to="/suburbs" className="text-gray-700 hover:text-accent transition-colors">
              Suburbs
            </Link>
            <a href="#contact" className="text-gray-700 hover:text-accent transition-colors">
              Book Now
            </a>
          </div>
          <div className="md:hidden">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setIsOpen(!isOpen)}
              aria-label="Toggle menu"
            >
              {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </Button>
          </div>
        </div>
        {isOpen && (
          <div className="md:hidden pb-4">
            <div className="flex flex-col space-y-4">
              <Link
                to="/sports-injury"
                className="text-gray-700 hover:text-accent transition-colors"
                onClick={() => setIsOpen(false)}
              >
                Sports Injury
              </Link>
              <Link
                to="/chronic-pain"
                className="text-gray-700 hover:text-accent transition-colors"
                onClick={() => setIsOpen(false)}
              >
                Chronic Pain
              </Link>
              <Link
                to="/post-surgery"
                className="text-gray-700 hover:text-accent transition-colors"
                onClick={() => setIsOpen(false)}
              >
                Post Surgery
              </Link>
              <Link
                to="/suburbs"
                className="text-gray-700 hover:text-accent transition-colors"
                onClick={() => setIsOpen(false)}
              >
                Suburbs
              </Link>
              <a
                href="#contact"
                className="text-gray-700 hover:text-accent transition-colors"
                onClick={() => setIsOpen(false)}
              >
                Book Now
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
